<template>
  <div class="record" id="record">
    <a class="alink" href="https://beian.miit.gov.cn/">京ICP备19028624号-3</a>
  </div>
</template>

<script>
export default {
  name: "record",
  props: {
    msg: String
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.alink {
  color: #333;
}
</style>
